/**
 * PaymentFailed Page
 * Displays payment failure message
 */

import React from 'react';
import './PaymentFailed.css';

export const PaymentFailed = () => {
  return (
    <div className="payment-status-page">
      <h1>Payment Failed</h1>
      <p>We couldn't complete your payment. Please try again or use a different card.</p>
      <a href="/login" className="payment-status-link">Back to app</a>
    </div>
  );
};
